import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { IdeaLanding } from 'components/IdeaLanding';
import NotFound from 'shared/components/NotFound';

interface RouteProps {
  id: string;
  ideaType: string;
}

export default ({ match: { params } }: RouteComponentProps<RouteProps>) =>
  !isNaN(+params.id) ? <IdeaLanding id={+params.id} /> : <NotFound />;
